import React from 'react';
import PortalFrame from '../portal/PortalFrame';

export default function SharedPageLayout(props) {
  return <PortalFrame {...props} />;
}
